import {makeStyles} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
    root: {
        '& + &': {
            marginTop: theme.spacing(5)
        }
    },
    header: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        lineHeight: 1.5,
        marginBottom: theme.spacing(2),
        [theme.breakpoints.up('lg')]: {
            marginBottom: theme.spacing(3)
        }
    },
    title: {
        fontWeight: 400
    },
    tooltipWrapper: {
        lineHeight: 0
    },
    tooltip: {
        [theme.breakpoints.up('md')]: {
            maxWidth: 500,
            minWidth: 500
        }
    }
}));

export default useStyles;
